module.exports = __webpack_public_path__ + "static/media/perguntas_active.aa4cf037.svg";